import React, { Fragment, useState, useEffect } from "react";
import Spinner from "../../layouts/Spinner";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import {  Show, useAccess } from "react-redux-permission";
import { getSettingApp, handleInputChange, handleSubmit } from '../../../redux/actions/settings_app/setting_app.actions';

function SettingsAppTheme ({ setting_app, getSettingApp, handleSubmit }) {

    useEffect(() => {
        getSettingApp();
    },[]);

    return (
        <div className="card card-p-200">
            <ReactTooltip  effect="solid" event="click"/>
            <div className="card-header">
                <h4 className="card-title">Themes  <a href="#" className="tool-tip" data-tip="this is a tool tip"><i className="la la-question-circle"></i></a></h4>
                <a className="heading-elements-toggle"><i className="la la-ellipsis-v font-medium-3"></i></a>
                <div className="heading-elements">
                    <ul className="list-inline mb-0"></ul>
                </div>
            </div>
            <div className="card-content collapse show">
                <div className="card-body">
                    {/* <Show when="inv.setting.app.view"> </Show> */}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    setting_app: state.setting_app
});

export default connect(mapStateToProps, { getSettingApp, handleSubmit })(SettingsAppTheme);
